import { Pin, X } from "lucide-react";
import { useState } from "react";
import styles from "./styles.module.scss";

interface OutreachTermsProps {
  terms?: string;
}

export function OutreachTerms({ terms }: OutreachTermsProps) {
  const [isOpen, setIsOpen] = useState(true);

  if (!isOpen) {
    return (
      <button
        type="button"
        title="Show Outreach Terms"
        className={styles.yellowButton}
        onClick={() => setIsOpen(true)}
      >
        <Pin size={14} className={styles.pinIcon} aria-hidden="true" />
        <span className={styles.buttonText}>Outreach Terms</span>
      </button>
    );
  }

  return (
    <div className={styles.outreachTermsCard}>
      <div className={styles.cardHeader}>
        <div className={styles.cardTitleWrap}>
          <Pin size={14} className={styles.pinIcon} aria-hidden="true" />
          <p className={styles.cardTitle}>Outreach Terms</p>
        </div>
        <button
          type="button"
          title="Collapse pinned note"
          className={styles.closeButton}
          onClick={() => setIsOpen(false)}
        >
          <X size={14} aria-hidden="true" />
        </button>
      </div>
      <div className={styles.cardBody}>
        <p className={styles.termsText}>
          {terms && terms.trim() ? terms : "No outreach terms specified."}
        </p>
      </div>
    </div>
  );
}
